import vueRouter from '../router'
import config, { inApp, isLocal, isTest } from '@/config'
import { goWebview } from '@/RNApp'
import { deviceType, verdictEmpty } from '@/utils/tools'

export const routerBaseUrl = () => isLocal() ? config.appUrl.test : !isTest() ? config.appUrl.dev : config.appUrl.pro
/**
 * 路由
 * @param params
 */
export const router = (params = {}) => {
  const url = getUrlQuery(params, false)
  // RN
  if (inApp()) {
    goWebview({
      url: url,
      title: params.title || '',
      shareObj: params.shareObj || 0,
      isShowTitle: params.isShowTitle || false,
    })
    return
  }
  if (params.isHttps) {
    window.location.href = url
    return false
  }
  vueRouter.push({
    path: params.path,
    query: params.query
  })
}

const getUrlQuery = (params, isNative) => {
  let { url = '' } = params || {}
  if (isNative) {
    // 匹配路由host
    if (!url.startsWith('http') && !url.startsWith('jadeking')) {
      url = routerBaseUrl() + (isLocal() ? '' : '/page') + '/#' + (url.startsWith('/') ? '' : '/') + url
    }
  }
  const { query = '' } = params || {}
  let query_string = '?'
  if (query && !verdictEmpty(query)) {
    Object.keys(query)
      .forEach((value, index) => {
        if (value !== 'inApp') {
          if (index === Object.keys(query).length - 1) {
            query_string += value + '=' + query[value]
          } else {
            query_string += value + '=' + query[value] + '&'
          }
        }
      })
  }
  // 原生路由（默认不显示标题栏）
  const { isShowTitle = '' } = query || {}
  if (isNative && isShowTitle === '') {
    query_string += ((query_string === '?' ? '' : '&') + 'isShowTitle=false')
  }
  // 控制是否需要原生用原生WebView打开
  if (isNative) {
    query_string += ((query_string === '?' ? '' : '&') + 'openNative=true')
  }
  return url + (query_string === '?' ? '' : query_string)
}

export const nativeRouter = params => {
  const url = getUrlQuery(params, true)
  if (deviceType()) {
    window.AndroidNative.JD_Route(url)
  } else {
    window.webkit.messageHandlers.JD_Route.postMessage(url)
  }
}

export const goBack = (isBackHome = false) => {
  if (deviceType()) {
    window.AndroidNative.JD_PopToRootController(isBackHome)
  } else {
    window.webkit.messageHandlers.JD_PopToRootController.postMessage(isBackHome)
  }
}

export const copy = (text = '') => {
  if (deviceType()) {
    window.AndroidNative.JD_Copy(text)
  } else {
    window.webkit.messageHandlers.JD_Copy.postMessage(text)
  }
}

export default {
  router,
  nativeRouter,
  goBack,
  copy
}

